import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import segment from '../core/segment';

function trackPage(pathname: string, userId?: string): void {
  segment.pageTrack(`${process.env.REACT_APP_CLIENT_PATH_PREFIX}${pathname}`, '', {
    userId,
    path: `${process.env.REACT_APP_CLIENT_PATH_PREFIX}${pathname}`,
    url: window.location.href,
  });
}

// you may ask won't this only fire when it changes and miss the first time?
// it will. The first time is handled in core/segment. That is missing all custom properties
// and as far as I can tell there is no way to pass them, even if you do it here.
// segment will just ignore the custom props for that first call.
export const useTrackPageChange = (): void => {
  const history: RouteComponentProps['history'] = useHistory();
  const userId = useSelector(
    (state: { fenderConnect: { userID: string } }) => state.fenderConnect.userID,
  );
  // note history.listen returns its own unlisten function which is why this is a one liner
  useEffect(() => history.listen(loc => trackPage(loc.pathname, userId)));
};

export default useTrackPageChange;
